<template>
  <div class="card-content tableWithPerPageSelection">
    <div class="columns">
      <figure class="column is-2">
        <app-logo readOnly class="is-pulled-left"
                  :elementId="this.tiersInformation.id"
                  :libelleElement="$t('detailClient.libelleClientForLogo',
                  { nomCommercial: this.tiersInformation.nomCommercial })">
        </app-logo>
      </figure>
      <div class="column is-10">
        <b-field class="is-marginless">
          <div class="title is-4 is-marginless">
            {{this.tiersInformation.nomCommercial}}
          </div>
        </b-field><br>
        <b-field class="is-marginless">
          <div class="is-4 is-marginless">
            {{this.tiersInformation.compteComptable}}
          </div>
        </b-field><br>
        <div class="columns">
          <div class="is-narrow">
            <div class="card pd-10px">
              {{ $t('compteTiers.solde') }}&nbsp;:&nbsp;
              <span :class="solde >= 0
              ? 'has-text-success' : 'has-text-danger'">
              {{ solde | formatDevise }}
              </span>
              <br>
              {{ $t('compteTiers.dateSolde') }}
              &nbsp;:&nbsp;
              {{ dateSolde | formatDate }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgb-10px">
      <div class="level-left columns">
        <form @submit.prevent="recherche()" v-if="critereRecherche !== undefined"
                class="column is-4">
            <b-input :placeholder="$t('compteTiers.actions.search')"
                      type="search"
                      icon="magnify"
                      v-model="critereRecherche.auto">
            </b-input>
        </form>
        <div class="column is-narrow">
          <button class="button" @click='setShowFiltre'>
            <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
            <span class="is-size-7">{{$t('compteTiers.actions.filtre')}}
              <label class="has-text-weight-bold"
                      :class="nombreCritere > 0 ? '' : 'is-invisible'">
                ({{ nombreCritere }})
              </label>
            </span>
          </button>
          <span @click="reinitialiser()"
            class="info-circle-right is-pulled-right is-cursor-pointer">
            <b-icon icon="close-circle" type="is-danger"></b-icon>
          </span>
        </div>
      </div>
      <div class="level-right">
        <exportExcelButton
              :perm="permRemisesOrLot.exporter"
              :query="exportExcelQuery"/>
        <parametrage-table
          class="mgl-10px"
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <div class="columns">
    </div>
    <v-server-table
      url="" :columns="columns" :options="options"
      :ref="referenceTable"
      @loaded="finLoading" @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <div slot="datePiece" slot-scope="props" class="is-pulled-left">
        {{ props.row.datePiece | formatDate }}
      </div>
      <div slot="typeDePiece" slot-scope="props" class="is-pulled-left">
        {{ getLibelleTypeDePiece(props.row) }}
      </div>
      <div slot="reference" slot-scope="props" class="is-pulled-left">
        <router-link-blank v-if="pieceAsLink(props.row) && getUrlPiece(props.row) !== null"
            :to="getUrlPiece(props.row)"
            :message="props.row.typeDePiece === constantes.OD ? getLibelleTypeDePiece(props.row)
              : props.row.reference"/>
        <span v-else>{{ props.row.reference }}</span>
      </div>
      <div slot="libelle" slot-scope="props" class="is-pulled-left">
        {{ getLibelleAvecCategorieProduitLocal(props.row) }}
      </div>
      <div slot="debit" slot-scope="props" class="is-pulled-right">
        {{ props.row.debit | formatDevise}}
      </div>
      <div slot="credit" slot-scope="props" class="is-pulled-right">
        {{ props.row.credit | formatDevise}}
      </div>
      <div slot="resteALettrer" slot-scope="props" class="is-pulled-right">
        {{ props.row.resteALettrer | formatDevise}}
      </div>
      <div slot="etatLettrage" slot-scope="props" class="is-pulled-left ">
        <router-link class="is-primary is-fullwidth"
            v-if="props.row.nbMouvementClient === 1"
            :class="[{ 'button-access-no-permission' :
            !checkPermissions(permRemisesOrLot.maj) || isEscompte(props.row)},
            { 'pointer-events-none' :
            !checkPermissions(permRemisesOrLot.maj) || isEscompte(props.row)}]"
            :to="{
            name: 'm.bodac.remises_bancaires-client',
            params: { id: props.row.id, isFromDetailClient: isFromDetailClient, } }">
          <b-icon :icon="isEscompte(props.row) ? 'eye-off' : 'eye'"
                  custom-size="mdi-18px"
                  :type="isEscompte(props.row) ? 'is-link' : 'is-primary'"/>
        </router-link >
        <a v-else @click="showPopupSelectionEcheance(props.row)">
          <b-icon :icon="isEscompte(props.row) ? 'eye-off' : 'eye'"
                 custom-size="mdi-18px"
                 :type="isEscompte(props.row) ? 'is-link' : 'is-primary'"/>
        </a>
        {{ $t(importedFunction.formatEtatLettrage(props.row.etatLettrage)) }}
      </div>
      <div slot="ecriture" slot-scope="props" class="has-text-centered colonne-selected">
        <a @click="showPopupEcriture(props.row)">
          <b-icon icon="eye" v-if="pieceAsLink(props.row)"
                 custom-size="mdi-18px"
                 type="is-primary"/>
        </a>
      </div>
      <div slot="commentaire" slot-scope="props" class="has-text-centered colonne-selected">
        <div v-if="props.row.commentaire" class="mgt-5px">
            <b-tooltip class="width-100percent"
                    multiline
                    type="is-warning"
                    position="is-left">
              <template v-slot:content>
                <div class="is-prewrap width-190px">{{props.row.commentaire}}</div>
              </template>
              <b-icon icon="alert" custom-size="mdi-24px" type="is-warning">
              </b-icon>
            </b-tooltip>
          </div>
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre">
        <filtre-compte-tiers
          ref="filtreCompteTiers"
          @toggleFiltre="setShowFiltre"
          v-model="critereRecherche"
          @recherche="recherche()"
          :nameStore="nameStore"/>
      </div>
    </transition>
    <b-modal v-model="displayPopupEcriture"
      has-modal-card
      class="modal" width="1280px">
      <popup-ecritures :piece="pieceSelected" />
    </b-modal>
    <b-modal v-model="displayPopupSelectionEcheance"
      has-modal-card
      class="modal" width="960px">
      <popup-selection-echeance :piece="pieceSelected" :societeId="societeActiveId" />
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import Logo from '@/components/general/Logo';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import filtreCompteTiers from '@/components/tiers/filtreCompteTiers';
import formatDate from '@/services/general/formatIsoDate';
import * as mouvementClientConf from '@/configuration/mouvementClient/mouvementClientConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import formatEtatLettrage from '@/services/general/formatEtatLettrage';
import { FACTURES, REMISES_BANCAIRES } from '@/configuration/permissionsBodacConf';
import popupEcritures from '@/components/compta/popupEcritures';
import getLibelleAvecCategorieProduit from '@/services/compteClient/getLibelleAvecCategorieProduit';
import popupSelectionEcheance from '@/components/factures/popupSelectionEcheance';
import TableItemsInView from '@/components/general/TableItemsInView';
import { LOT_PAIEMENT } from '@/configuration/baux/permissionsBauxConf';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_COMPTE_TIERS } from '@/configuration/general/referenceTableConf';
import { EXPORT_EXCEL_COMPTE_TIER } from '@/configuration/tiers/tiersConf';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import transformerCompteClient from '@/services/compteClient/transformerCompteClient';
import { MODULE_TLPE, MODULE_ACHAT } from '@/configuration/devisConf';

const societe = createNamespacedHelpers('societe');
const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'CompteTiers',
  props: {
    tiersId: String,
    soldeTiersInfo: Number,
    soldeAtInfiniteDay: {
      type: Number,
      required: true,
    },
    tiersInformation: Object,
    isFromDetailClient: {
      type: Boolean,
      default: true,
    },
    nameStore: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showFiltre: false,
      importedFunction: {
        formatEtatLettrage,
      },
      permFactures: FACTURES,
      permRemisesOrLot: this.isFromDetailClient ? REMISES_BANCAIRES : LOT_PAIEMENT,
      displayPopupEcriture: false,
      displayPopupSelectionEcheance: false,
      pieceSelected: null,
      referenceTable: REFERENCE_TABLE_COMPTE_TIERS,
      constantes: {
        OD: mouvementClientConf.OD,
      },
      mountedLoadingEnd: false,
      startArrayRendering: false,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    appLogo: Logo,
    filtreCompteTiers,
    routerLinkBlank,
    popupEcritures,
    popupSelectionEcheance,
    TableItemsInView,
    parametrageTable,
    exportExcelButton,
  },
  methods: {
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    actionLoadCompte(filter) {
      return this.$store.dispatch(`${this.nameStore}/loadCompteClient`, filter);
    },
    actionLoadSolde(tiersId) {
      return this.$store.dispatch(`${this.nameStore}/loadSoldeClient`, tiersId);
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) this.$refs.filtreCompteTiers.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    getLibelleTypeDePiece(piece) {
      const type = mouvementClientConf.LISTE_TYPE_PIECE.find((type) => {
        return type.code === piece.typeDePiece;
      });
      return type ? this.$i18n.t(type.libelle) : '';
    },
    pieceAsLink(piece) {
      return piece.typeDePiece === mouvementClientConf.FACTURE
        || piece.typeDePiece === mouvementClientConf.AVOIR
        || piece.typeDePiece === mouvementClientConf.ACOMPTE
        || piece.typeDePiece === mouvementClientConf.REGLEMENT
        || piece.typeDePiece === mouvementClientConf.OD
        || piece.typeDePiece === mouvementClientConf.CHARGE
        || piece.typeDePiece === mouvementClientConf.AVOIR_DE_CHARGE
        || piece.typeDePiece === mouvementClientConf.PAIEMENT;
    },
    getUrlPiece(piece) {
      switch (piece.typeDePiece) {
        case mouvementClientConf.FACTURE:
        case mouvementClientConf.AVOIR:
        case mouvementClientConf.ACOMPTE:
          return {
            name: 'c.bodac.factures',
            params: { id: piece.pieceId },
          };
        case mouvementClientConf.REGLEMENT:
          return {
            name: 'c.bodac.remises_bancaires',
            params: { id: piece.pieceId },
          };
        case mouvementClientConf.OD:
          return {
            name: 'c.comptabilite.operation_diverse',
            params: { id: piece.operationDiverseId },
          };
        case mouvementClientConf.CHARGE:
        case mouvementClientConf.AVOIR_DE_CHARGE:
          if (piece.module === MODULE_TLPE) {
            return {
              name: 'c.gabed.titre_recette',
              params: { id: piece.pieceId },
            };
          }
          if (piece.module === MODULE_ACHAT) {
            return {
              name: 'c.achat.factures',
              params: { id: piece.pieceId },
            };
          }
          return { name: 'c.baux.facture_achat', params: { id: piece.pieceId } };
        case mouvementClientConf.PAIEMENT:
          if (piece.module === MODULE_TLPE) {
            return {
              name: 'c.gabed.lot_paiement_recette',
              params: { id: piece.pieceId },
            };
          }
          if (piece.module === MODULE_ACHAT) {
            return {
              name: 'c.achat.lot_paiements_factures',
              params: { id: piece.pieceId },
            };
          }
          return {
            name: 'c.baux.lot_paiement',
            params: { id: piece.pieceId },
          };
        default: return null;
      }
    },
    isEscompte(piece) {
      if (piece === undefined || piece === null) return false;
      return piece.typeDePiece === mouvementClientConf.ESCOMPTE;
    },
    showPopupEcriture(piece) {
      this.pieceSelected = piece;
      this.displayPopupEcriture = true;
    },
    showPopupSelectionEcheance(piece) {
      this.pieceSelected = piece;
      this.displayPopupSelectionEcheance = true;
    },
    getLibelleAvecCategorieProduitLocal(piece) {
      return getLibelleAvecCategorieProduit(piece);
    },
    reinitialiser() {
      this.$refs.filtreCompteTiers.initializeFiltre();
      this.$refs.filtreCompteTiers.viderCritere();
      this.$refs.filtreCompteTiers.appliquerCritere();
      this.showFiltre = false;
    },
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    critereRecherche() {
      return this.$store.getters[`${this.nameStore}/critereRecherche`];
    },
    items() {
      return this.$store.getters[`${this.nameStore}/items`];
    },
    total() {
      return this.$store.getters[`${this.nameStore}/total`];
    },
    lastPayload() {
      return this.$store.getters[`${this.nameStore}/lastPayload`];
    },
    solde() {
      return this.$store.getters[`${this.nameStore}/solde`];
    },
    dateSolde() {
      return this.$store.getters[`${this.nameStore}/dateSolde`];
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_COMPTE_TIER,
        typeExport: '',
        filtres: transformerCompteClient(this.lastPayload),
      };
    },
    columns() {
      return ['datePiece', 'typeDePiece', 'reference', 'libelle', 'debit', 'credit',
        'resteALettrer', 'etatLettrage', 'ecriture', 'commentaire'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          datePiece: this.$i18n.t('compteTiers.date'),
          typeDePiece: this.$i18n.t('compteTiers.type'),
          reference: this.$i18n.t('compteTiers.numero'),
          libelle: this.$i18n.t('compteTiers.libelle'),
          debit: this.$i18n.t('compteTiers.debit'),
          credit: this.$i18n.t('compteTiers.credit'),
          resteALettrer: this.$i18n.t('compteTiers.resteAlettrer'),
          etatLettrage: this.$i18n.t('compteTiers.etatLettrage'),
          ecriture: this.$i18n.t('compteTiers.ecriture'),
          commentaire: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['datePiece', 'typeDePiece', 'reference', 'libelle', 'debit', 'credit',
          'resteALettrer', 'etatLettrage'],
        requestFunction: ((filter) => {
          if (this.critereRecherche !== undefined && this.critereRecherche !== null) {
            filter.query = cloneDeep(this.critereRecherche);
            filter.query.tiersId = this.tiersId;
            filter.query.societeId = this.societeActiveId;

            if (filter.query.numero.length === 0) delete (filter.query.numero);
            if (filter.query.libelle.length === 0) delete (filter.query.libelle);
            if (filter.query.periode !== undefined
              && (filter.query.periode.dateDebut === undefined
              || filter.query.periode.dateDebut === null)
              && (filter.query.periode.dateFin === undefined
              || filter.query.periode.dateFin === null)) {
              delete (filter.query.periode);
            } else {
              filter.query.periode.dateDebut = formatDate(filter.query.periode.dateDebut);
              filter.query.periode.dateFin = formatDate(filter.query.periode.dateFin);
            }
            if (filter.query.debit !== undefined
              && ((filter.query.debit.borneBasse === undefined
                  || filter.query.debit.borneBasse === 0)
                && (filter.query.debit.borneHaute === undefined
                  || filter.query.debit.borneHaute === 999999999))
              || (filter.query.debit.borneBasse !== undefined
                && filter.query.debit.borneBasse === 0
                && filter.query.debit.borneHaute !== undefined
                && filter.query.debit.borneHaute === 0)) {
              delete (filter.query.debit);
            }
            if (filter.query.credit !== undefined
              && ((filter.query.credit.borneBasse === undefined
                  || filter.query.credit.borneBasse === 0)
                && (filter.query.credit.borneHaute === undefined
                  || filter.query.credit.borneHaute === 999999999))
              || (filter.query.credit.borneBasse !== undefined
                && filter.query.credit.borneBasse === 0
                && filter.query.credit.borneHaute !== undefined
                && filter.query.credit.borneHaute === 0)) {
              delete (filter.query.credit);
            }
            if (filter.query.types.length === 0) delete (filter.query.types);
            if (filter.query.etats.length === 0) delete (filter.query.etats);
            if (filter.query.auto.length === 0) delete (filter.query.auto);
          } else {
            filter.query = {
              tiersId: this.tiersId,
              societeId: this.societeActiveId,
            };
          }

          return this.actionLoadCompte(filter);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.total,
          };
        }),
      };
    },
    nombreCritere() {
      let nombreCritere = 0;
      if (this.critereRecherche === undefined) return nombreCritere;
      nombreCritere += this.critereRecherche.numero.length ? 1 : 0;
      nombreCritere += this.critereRecherche.libelle.length ? 1 : 0;
      nombreCritere += this.critereRecherche.types.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.etats.length > 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.periode.dateDebut !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.periode.dateFin !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.debit.borneBasse !== 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.debit.borneHaute !== 999999999 ? 1 : 0;
      nombreCritere += this.critereRecherche.credit.borneBasse !== 0 ? 1 : 0;
      nombreCritere += this.critereRecherche.credit.borneHaute !== 999999999 ? 1 : 0;

      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
  },
  async mounted() {
    this.setInformationPage(this.$t('pageGeneral.detail',
      { item: this.tiersInformation.nomCommercial }));
    await this.actionLoadSolde(this.tiersInformation.id);
    this.mountedLoadingEnd = true;
  },
};
</script>

<style scoped>

</style>
